import { useForm } from 'react-hook-form'
import { HeadingPages } from '../../../components/HeadingPages'
import { Filtro } from './Filtro'
import { TableContasReceber } from './Tabela'
import { format } from 'date-fns'
import { formatPrice } from '../../../utils/formatPrice'

import { useContasReceber } from './contexts/ContasReceberProvider'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { Button } from '@chakra-ui/button'
import { MdPictureAsPdf } from 'react-icons/md'
import { Icon, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import Axios from 'axios'

export function ContasReceber() {
  const { data } = useContasReceber()

  const statusText = (status) => {
    const label = {
      N: 'Pago',
      S: 'Pendente',
      A: 'Atrasado',
      R: 'A receber',
    }

    return label[status]
  }

  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'in',
      format: [(document.documentElement.clientWidth * 0.8) / 72, (document.documentElement.clientHeight * 0.8) / 72],
    })

    doc.setFontSize(8)

    doc.autoTable({
      head: [
        [
          'EMP',
          'RAZÃO SOCIAL',
          'PEDIDO',
          'Nº PEDIDO',
          'VENC',
          'BAIXA',
          'PGTO',
          'NRO NFE',
          'VLR PEDIDO',
          'VLR PAGO',
          'ATRASO',
          // "OBS OP",
          'PAGARME',
          'TIPO PGTO',
          'USUÁRIO BAIXA',
          'STATUS',
          'HISTÓRICO',
        ],
      ],
      body: [
        ...data.map((item) => [
          item.empresa.length > 10 ? item.empresa.substring(0, 20) + '...' : item.empresa,
          item.razao_social.length > 15 ? item.razao_social.slice(0, 15) + '...' : item.razao_social,
          item.data_pedido ? format(new Date(item.data_pedido), 'dd/MM/yyyy') : '',
          item.numero_pedido,
          item.data_vencimento ? format(new Date(item.data_vencimento), 'dd/MM/yyyy') : '',
          item.data_baixa ? format(new Date(item.data_baixa), 'dd/MM/yyyy') : '',
          item.data_pagamento ? format(new Date(item.data_pagamento), 'dd/MM/yyyy') : '',
          item.numero_nfe,
          formatPrice(item.valor_pedido),
          formatPrice(item.valor_pago),
          item.dias_atraso,
          item.codigo_pagarme,
          // item.observacao !== '' ? item.observacao.substring(0, 20) + "..." : "Não tem",
          item.tipo_pagamento,
          item.usuario_baixa,
          statusText(item.pendente),
          item.historico !== '' ? item.historico : 'Não tem',
        ]),
      ],

      margin: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      //alinhar ao centro
      styles: { cell: { fontSize: 12 }, halign: 'center' },
      // theme: "grid",
    })

    doc.setFontSize(8)
    doc.save(`Contas a Receber - ${format(new Date(), 'dd/MM/yyyy' + ' ' + 'HH:mm')}.pdf`)
  }

  const [loading, setLoading] = useState(false)

  async function generateExcel() {
    if (!data) return
    if (data.length === 0) return

    setLoading(true)

    const header = [
      'EMP',
      'RAZÃO SOCIAL',
      'PEDIDO',
      'Nº PEDIDO',
      'VENC',
      'BAIXA',
      'PGTO',
      'NRO NFE',
      'VLR PEDIDO',
      'VLR PAGO',
      'ATRASO',
      // "OBS OP",
      'PAGARME',
      'TIPO PGTO',
      'USUÁRIO BAIXA',
      'STATUS',
      'HISTÓRICO',
    ]

    const dataItems = data?.map((item) => {
      return {
        empresa: item.empresa.length > 10 ? item.empresa.substring(0, 20) + '...' : item.empresa,
        razao_social: item.razao_social.length > 15 ? item.razao_social.slice(0, 15) + '...' : item.razao_social,
        data_pedido: format(new Date(item.data_pedido), 'dd/MM/yyyy HH:mm'),
        numero_pedido: item.numero_pedido,
        data_vencimento: item.data_vencimento ? format(new Date(item.data_vencimento), 'dd/MM/yyyy HH:mm') : '',
        data_baixa: item.data_baixa ? format(new Date(item.data_baixa), 'dd/MM/yyyy HH:mm') : '',
        data_pagamento: item.data_pagamento ? format(new Date(item.data_pagamento), 'dd/MM/yyyy HH:mm') : '',
        numero_nfe: item.numero_nfe,
        valor_pedido: formatPrice(item.valor_pedido),
        valor_pago: formatPrice(item.valor_pago),
        dias_atraso: item.dias_atraso,
        codigo_pagarme: item.codigo_pagarme,
        // item.observacao !== '' ? item.observacao.substring(0, 20) + "..." : "Não tem",
        tipo_pagamento: item.tipo_pagamento,
        usuario_baixa: item.usuario_baixa,
        status: statusText(item.pendente),
        historico: item.historico !== '' ? item.historico : 'Não tem',
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  const counterNumPed = data.filter((item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index).length

  return (
    <>
      <HeadingPages name="Contas a Receber" />
      <Filtro />
      <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'1rem'}>
        {counterNumPed} Pedidos
      </Text>
      <Button
        bgColor="red.500"
        color="white"
        _hover={data.length === 0 ? { bgColor: 'red.500', cursor: 'not-allowed' } : { filter: 'brightness(0.9)' }}
        _active={data.length === 0 ? { bgColor: 'red.500', cursor: 'not-allowed' } : { filter: 'brightness(0.9)', transform: 'scale(0.98)' }}
        mb=".7rem"
        onClick={generatePDF}
        border={0}
        borderRadius="0"
        _focus={{ border: 0, outline: 0 }}
        disabled={data.length === 0}
      >
        <Icon as={MdPictureAsPdf} fontSize="1.8rem" mr=".7rem" color="white" />
        Gerar PDF
      </Button>

      <Button
        bgColor="green.500"
        color="white"
        ml="1rem"
        _hover={data.length === 0 ? { bgColor: 'green.500', cursor: 'not-allowed' } : { filter: 'brightness(0.9)' }}
        _active={data.length === 0 ? { bgColor: 'green.500', cursor: 'not-allowed' } : { filter: 'brightness(0.9)', transform: 'scale(0.98)' }}
        mb=".7rem"
        onClick={generateExcel}
        border={0}
        borderRadius="0"
        _focus={{ border: 0, outline: 0 }}
        disabled={data.length === 0}
        isLoading={loading}
      >
        <Icon as={MdPictureAsPdf} fontSize="1.8rem" mr=".7rem" color="white" />
        Gerar Excel
      </Button>

      <TableContasReceber />
    </>
  )
}
